module.exports = __webpack_public_path__ + "static/media/setecoqueiros-partitura.11cc219b.png";